import {
  displayNameForTimesheetUserId,
  normalizeTimesheetRowUserId,
  resolveTeamRowUserId,
} from "@/utils/timesheetRosterLookup";

/**
 * Add synthetic team rows for Django user ids seen in timesheets but missing from
 * team-members API (e.g. former staff when include_not_working is blocked).
 */
export function enrichTeamRowsFromTimesheetUsers(
  teamRows,
  timesheetRows,
  rosterLookup
) {
  const rows = [...(teamRows || [])];
  const haveUserId = new Set();
  rows.forEach((row) => {
    const uid = resolveTeamRowUserId(row);
    if (uid != null) haveUserId.add(uid);
  });

  const added = new Set();
  (timesheetRows || []).forEach((row) => {
    const uid = normalizeTimesheetRowUserId(row);
    if (uid == null || haveUserId.has(uid) || added.has(uid)) return;
    added.add(uid);
    haveUserId.add(uid);
    const name = displayNameForTimesheetUserId(rosterLookup, uid);
    rows.push({
      id: null,
      user_id: uid,
      full_name: name && !name.startsWith("User ") ? name : `User ${uid}`,
      is_currently_working: false,
    });
  });

  return rows;
}
